import { FC } from 'react'

import { useFootnoteFooterContext } from '@/contexts'
import classNames from 'classnames'
import { COLORS, Layout } from 'ethos-design-system'

import { usePricingStats } from '@/hooks/features/usePricingStats'
import { useRebrandingTreatment } from '@/hooks/features/useRebrandingRefresh'
import { useWreathsFooterUpdate } from '@/hooks/features/useWreathsFooterUpdate'

import Markdown, { MARKDOWN_NODE_RESTRICTION_SETS } from '../../Markdown'
import styles from './FootnoteFooter.module.scss'

interface IFootnoteFooter {
  footNoteColor?: any
}

const FootnoteFooter: FC<IFootnoteFooter> = ({
  footNoteColor = COLORS.WHITE,
}) => {
  const { displayFootnoteFooter, bodyText: defaultBodyText } =
    useFootnoteFooterContext()

  const { isTreatment } = useWreathsFooterUpdate()

  const {
    isTreatment: isPricingStatsTreatment,
    isTreatment1: isPricingStatsTreatment1,
  } = usePricingStats()

  const { isEnabled: isNewFonts } = useRebrandingTreatment()

  if (!displayFootnoteFooter) return null

  let experimentBodyText = defaultBodyText

  if (experimentBodyText.length === 0) return null

  if (isPricingStatsTreatment) {
    // Removing CNBC only for treatments
    experimentBodyText = experimentBodyText.replace(
      'Best burial insurance according to CNBC as of 3/2025.',
      ''
    )
    experimentBodyText += '\n\n'
    experimentBodyText += isPricingStatsTreatment1
      ? '50% savings based on Q1 2025 rates for a 40-year-old male with standard health risk, comparing a $1 million 20-year term policy for $136/month compared to published rates from a national carrier ($313/month). Actual rates depend on underwriting and may vary by term, coverage, health, and state.'
      : '45+% savings is based on comparing Ethos policy rates (avg $247/month) for 40-60 year olds having standard health risk with published rates from a national carrier (avg $471/month). Actual rates depend on underwriting and may vary by term, coverage, health, and state.'
  }

  return (
    <Layout.HorizontallyPaddedContainer>
      <div
        id="footnote"
        className={classNames(styles.root, {
          [styles.treatment]: isTreatment,
        })}
      >
        <div
          className={classNames(styles.footnoteText, {
            [styles.newFonts]: isNewFonts,
          })}
        >
          <Markdown
            input={experimentBodyText || ''}
            allowedMarkdownTypes={
              MARKDOWN_NODE_RESTRICTION_SETS.BASIC_TEXT_WITH_LINKS
            }
          />
        </div>
      </div>
    </Layout.HorizontallyPaddedContainer>
  )
}

export default FootnoteFooter
